import React, { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles, Typography } from '@material-ui/core';
import { ErrorOutlined } from '@material-ui/icons';

import { i18n } from '../../translate/i18n';
import DefaultFunctionsUtils from '../../utils/classes/DefaultFunctionsUtils';
import DefaultValuesUtils from '../../utils/classes/DefaultValuesUtils';

const useStyles = makeStyles(theme => ({
  floatingButton: {
    cursor: 'pointer'
    , transition: 'transform 0.3s'
    , '&:hover': { transform: 'translateY(-5px)' }
  }
}));

const MessageException = ({ message }) => {
  //  ****************
  //  ** Attributes **
  //  ****************
  const classes = useStyles();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [messageProperty, setMessageProperty] = useState(undefined);

  //  *****************
  //  ** Use Effects **
  //  *****************
  useEffect(() => {
    if (!isModalOpen) return;
    if (message.messageProperties?.length === 0) return;
    setMessageProperty(DefaultFunctionsUtils.extractMessageProperty(message, DefaultValuesUtils.MESSAGE_PROPERTIES.KEYS.SENDING_EXCEPTION));
  }, [isModalOpen, message]);

  //  *************
  //  ** Methods **
  //  *************
  const handleModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const renderExceptionDescription = () => {
    const exceptionDescription = messageProperty?.propertyValue?.toLowerCase() ?? DefaultValuesUtils.MESSAGE_PROPERTIES.VALUES.GATEWAY_RESPONSE.toLowerCase();

    return (
      <Typography>{i18n.t(`messageException.modalMessage.${exceptionDescription}`)}</Typography>
    );
  };

  const renderModal = () => {
    return (
      <Dialog open={isModalOpen} onClose={handleModalClose} maxWidth='sm' scroll='paper' fullWidth>
        <DialogTitle>
          {i18n.t('messageException.title')}
        </DialogTitle>

        <DialogContent dividers>
          {renderExceptionDescription()}
        </DialogContent>

        <DialogActions>
          <Button color='inherit' variant='outlined' onClick={handleModalClose} className={classes.floatingButton}>
            {i18n.t('messageException.buttons.close')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  //  ************
  //  ** Return **
  //  ************
  return (
    <React.Fragment>
      {'\u00a0'}
      <ErrorOutlined className={classes.floatingButton} color='primary' onClick={handleModalOpen} />
      {renderModal()}      
    </React.Fragment>
  );
};

export default MessageException;
